import ConfirmDialog from "./confirm-dialog.vue";

const loadPromise = new Promise(resolve => {
  vueApp.component('confirm-dialog', ConfirmDialog);
  resolve();
});

window.pendingComponentLoads.push(loadPromise);